import { jsx as u } from "react/jsx-runtime";
import i, { useRef as O, useState as m } from "react";
import { u as j } from "./index-6a632112.mjs";
import { a as D, c as L, C as d } from "./createOptions-4792754a.mjs";
import { c as N, Q as U } from "./themes-5f0b3c3d.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./lineHeights-72d3110c.mjs";
const { legendStyles: _, tooltipStyles: k } = D({
  type: d.DONUT
}), v = j.div`
  ${k};
  ${_()};
  .apexcharts-tooltip {
    background: ${N.brandTwilight[0]};
  }
  min-height: 350px;

  .apx-legend-position-right,
  .apx-legend-position-left {
    justify-content: ${({ $legendScroll: t }) => t ? "unset !important" : "center !important"};
  }
  @media ${U.mobile} {
    min-height: 450px;
    .apexcharts-legend {
      max-height: ${({ $legendMaxHeight: t }) => t || 200}px !important;
    }
  }
`, Y = ({
  chartLibElement: t,
  legend: a,
  isCategorical: g = !0,
  colorPallete: x = ["blue"],
  hideLabel: S = !1,
  labelFormatter: y,
  series: r,
  labels: $,
  dataLabels: l,
  hideTooltip: E,
  height: c,
  width: p,
  legendClick: f
}) => {
  const [h, H] = i.useState(!1), s = O(null), [b, R] = m(!1), [T, w] = m(200);
  i.useEffect(() => {
    H(!h);
  }, [l, a?.showTotal]), i.useEffect(() => {
    const n = s?.current?.offsetHeight;
    n && w(n * 0.4);
    const o = s?.current?.querySelector(
      ".apexcharts-legend"
    );
    o?.scrollHeight > o?.offsetHeight && R(!0);
  }, [r]);
  const e = L({
    legend: a,
    isCategorical: g,
    colorPallete: x,
    hideLabel: S,
    labelFormatter: y,
    type: d.DONUT,
    series: r,
    labels: $,
    dataLabels: l,
    hideTooltip: E
  });
  e.tooltip = {
    ...e.tooltip,
    fillSeriesColor: !1,
    borderRadius: 5,
    theme: !1
  }, e.chart = {
    ...e.chart,
    events: {
      legendClick: function(n, o, M) {
        f && f(o);
      }
    }
  };
  const C = r;
  return /* @__PURE__ */ u(
    v,
    {
      className: "donut-chart",
      "data-testid": "donut-chart-wrapper",
      ref: s,
      $legendScroll: b,
      $legendMaxHeight: T,
      children: /* @__PURE__ */ u(
        t,
        {
          width: p ? `${p}px` : "100%",
          height: c ? `${c}px` : "100%",
          options: e,
          series: C,
          type: "donut"
        },
        h ? 0 : 1
      )
    }
  );
};
export {
  Y as DonutChart
};
